module.exports = __webpack_public_path__ + "media/images/general/sns/logo-instagram-cb460962fe56ecd5d008c16278f65002.svg";